import { ClientsApiAdapter } from '../adapters/ClientsApiAdapter';
import { ClientsModel } from '../models/Clients';
import { Filters } from '../models/Filters';

export interface Page {
    clients: ClientsModel[];
    nextPage?: number;
    hasMore: boolean;
    total: number;
}

export class Service {
    constructor(private apiAdapter: ClientsApiAdapter) { }

    async getAllClients(): Promise<ClientsModel[]> {
        return this.apiAdapter.getAll();
    }

    async getPaginated(filters: Filters = {}): Promise<Page> {
        const { searchTerm, limit } = filters;

        if (limit && limit > 100) {
            throw new Error('El límite no puede ser mayor a 100');
        }

        if (searchTerm && searchTerm.length < 2) {
            throw new Error(
                'El término de búsqueda debe tener al menos 2 caracteres'
            );
        }

        return this.apiAdapter.getClientsPaginated(filters);
    }
}

